import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import * as Converter from "../converter";
import { RESERVATION_LIST_BY_C_IN_DATE_FOR_MANAGEMENT_RESERVATION_SEARCH_CALENDAR_QUERY } from "../schema";

import type * as Type from "../type";

type Props = {
	hotelID: string;
	from: string;
	to: string;
};
type Result = {
	reservationListByCInDateQueryData: Type.QueryData.ReservationListQueryData;
};

export const useReservationListByCInDateQuery = ({ hotelID, from, to }: Props): Result => {
	const { data } = useCustomSuspenseQuery(
		RESERVATION_LIST_BY_C_IN_DATE_FOR_MANAGEMENT_RESERVATION_SEARCH_CALENDAR_QUERY,
		{
			variables: { hotelID, from, to },
		},
	);

	const { onConvertQueryData } = Converter.useReservationListByCInDateQueryData();
	const { queryData } = onConvertQueryData({ serverData: data });

	return {
		reservationListByCInDateQueryData: queryData,
	};
};
